import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import InputSymbol from '../CommonFunctions/InputSymbol';
import InputPositiveNumber from '../CommonFunctions/InputPositiveNumber';
import { Dispatch } from 'redux';
import { ChartConLabelFormates } from '../../../redux/ChartPoperties/ChartControlsInterface';
import { updateFormatOption } from '../../../redux/ChartPoperties/ChartControlsActions';
import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';
import { updateFormatForDm } from '../../../redux/DynamicMeasures/DynamicMeasuresActions';
import { FormControl, MenuItem, Select, Checkbox, Tooltip, TextField } from '@mui/material';
import { IndChartPropProperties } from '../../../redux/ChartPoperties/ChartPropertiesInterfaces';
import DateFormat from './DateFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import {
  getMeasureFieldsIncludingDateTimeGrain,
  getNameFromUid,
} from '../../CommonFunctions/CommonFunctions';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const LabelFormatting = ({
  //props
  formatFor,
  measuresListForTooltip,
  // state
  chartProperties,
  tabTileProps,
  chartControls,
  dynamicMeasureState,

  // dispatch
  updateFormat,
  updateFormatForDm,
  updateFormatX,
  updateFormatY,
  iconColor,
  backgroundColor,
}: ChartOptionsProps &
  any & {
    updateFormat: (propKey: string, formatType: any, option: string, value: any) => void;
    iconColor?: string;
    backgroundColor?: string;
  }) => {
  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const chartType = chartProperties.properties[propKey].chartType;
  const dmKey = `${dynamicMeasureState.selectedTileId}.${dynamicMeasureState.selectedDynamicMeasureId}`;

  const { tooltipFormats, chartAxes } = useSelector((state: RootState) => ({
    tooltipFormats: state.chartControls.properties[propKey].formatOptions.tooltipFormats,
    chartAxes: state.chartProperties.properties[propKey].chartAxes,
  }));
  const scatterDimensionField =
    chartType === 'scatterPlot' && chartProperties.properties[propKey].chartAxes[1]?.fields[0];
  const [selectedMeasure, setSelectedMeasure] = useState<any>(
    scatterDimensionField ||
      chartProperties.properties[propKey].chartAxes[
        chartProperties.properties[propKey].chartAxes.findIndex(
          (item: any) =>
            item.name === 'Measure' || item.name === 'X Axis' || item.name === 'Y Axis',
        )
      ]?.fields[0],
  );

  let formatObject: ChartConLabelFormates | any;
  if (formatFor === 'tooltip') {
    formatObject =
      chartType === 'richText'
        ? dynamicMeasureState.dynamicMeasureProps?.[`${dynamicMeasureState.selectedTabId}`]?.[
            `${dynamicMeasureState.selectedTileId}`
          ]?.[dmKey]?.formatOptions.tooltipFormats
        : chartControls.properties[propKey].formatOptions.tooltipFormats;
  } else {
    formatObject =
      chartType === 'richText'
        ? dynamicMeasureState.dynamicMeasureProps?.[`${dynamicMeasureState.selectedTabId}`]?.[
            `${dynamicMeasureState.selectedTileId}`
          ]?.[dmKey]?.formatOptions.labelFormats
        : chartControls.properties[propKey].formatOptions.labelFormats;
  }

  const formatOptions: any[] = [
    { type: 'Number', value: 'Number' },
    { type: 'Currency', value: 'Currency' },
    { type: 'Percent', value: 'Percent' },
  ];

  const [measuresList, setMeasuresList] = useState<any[]>(measuresListForTooltip || []);

  useEffect(() => {
    // sets the initial value of the measure dropdown to the first measure in the chart
    if (formatFor === 'tooltip') {
      handleUpdateFormat(
        'selectedMeasure',
        {
          name: selectedMeasure?.displayname,
          uId: selectedMeasure?.uId,
        },
        'tooltipFormats',
      );

      // check if already measure format is added by checking if measureFormat object is empty or not
      if (
        Object.keys(chartControls.properties[propKey].formatOptions.tooltipFormats.measureFormats)
          .length === 0
      ) {
        handleUpdateFormat(
          'measureFormats',
          {
            ...chartControls.properties[propKey].formatOptions.tooltipFormats.measureFormats,
            [selectedMeasure?.uId]: {
              formatValue: 'Number',
              currencySymbol: '$',
              enableRounding: true,
              roundingDigits: 1,
              numberSeparator: 'Abbrev',
              percentageCalculate: false,
            },
          },
          'tooltipFormats',
        );
      } else {
        handleUpdateFormat(
          'measureFormats',
          {
            ...chartControls.properties[propKey].formatOptions.tooltipFormats.measureFormats,
          },
          'tooltipFormats',
        );
      }
    } else {
      handleUpdateFormat(
        'selectedMeasure',
        {
          name: selectedMeasure?.displayname,
          uId: selectedMeasure?.uId,
        },
        'labelFormats',
      );

      // check if already measure format is added by checking if measureFormat object is empty or not

      if (
        selectedMeasure?.uId &&
        Object.keys(chartControls.properties[propKey].formatOptions.labelFormats.measureFormats)
          .length === 0
      ) {
        handleUpdateFormat(
          'measureFormats',
          {
            ...chartControls.properties[propKey].formatOptions.labelFormats.measureFormats,
            [selectedMeasure.uId]: {
              formatValue: 'Number',
              currencySymbol: '$',
              enableRounding: true,
              roundingDigits: 1,
              numberSeparator: 'Abbrev',
              percentageCalculate: false,
            },
          },
          'labelFormats',
        );
      } else {
        handleUpdateFormat(
          'measureFormats',
          {
            ...chartControls.properties[propKey].formatOptions.labelFormats.measureFormats,
          },
          'labelFormats',
        );
      }
    }
  }, []);

  //measureList contains fields with timegrain date in row or column and all fields in measure. By default selectedMeasure state will have field from measure(any type).
  const selectedField = measuresList.find((field) => field?.uId === selectedMeasure?.uId);

  let isTextType = false;
  let isDateType = false;
  (function () {
    if (selectedField) {
      if (
        (selectedField.timeGrain === 'month' || selectedField.timeGrain === 'quarter') &&
        !selectedField.agg
      ) {
        isTextType = true;
        isDateType = false;
        return;
      }
      if (selectedField && selectedField.timeGrain === 'date') {
        if (selectedField.agg) {
          if (selectedField.agg === 'min' || selectedField.agg === 'max') {
            isDateType = true;
          } else {
            isDateType = false;
          }
        } else {
          isDateType = true;
        }
      }
      if (selectedField.dataType) {
        const type = selectedField.dataType.toLowerCase();
        const isPrimitiveText = type === 'text' || type === 'string' || type === 'boolean';

        if (isPrimitiveText) {
          if (selectedField.agg && selectedField.agg !== 'min' && selectedField.agg !== 'max') {
            isTextType = false;
          } else {
            isTextType = true;
          }
        }
      }
    }
  })();

  useEffect(() => {
    const chartProps: IndChartPropProperties = chartProperties.properties[propKey];
    const chartAxes = Array.isArray(chartProps.chartAxes) ? chartProps.chartAxes : [];
    let measures: any = [];

    if (chartProperties.properties[propKey].chartType === 'scatterPlot') {
      measures = chartAxes[1]?.fields || [];
    } else {
      const response = getMeasureFieldsIncludingDateTimeGrain(chartAxes);
      measures = [...response];
    }
    setMeasuresList(measures);
  }, [chartProperties]);

  useEffect(() => {
    if (formatFor === 'tooltip') {
      setMeasuresList(measuresListForTooltip || []);
    }
  }, [measuresListForTooltip, formatFor]);

  // useEffect(() => {
  //   isDateType &&
  //     updateFormat(propKey, 'dateFormats', 'selectedMeasureName', selectedMeasure.displayname);
  // }, []);

  const handleUpdateFormat = (option: string, value: any, optionKey?: string) => {
    if (chartType === 'richText') {
      updateFormatForDm(dmKey, option, value);
    } else {
      updateFormat(propKey, optionKey, option, value);
    }
  };

  const renderFormatOptions = () => {
    return formatOptions.map((item: any) => {
      const isSelected =
        item.value === formatObject?.measureFormats[formatObject.selectedMeasure?.uId]?.formatValue;

      return (
        <div
          key={item.value}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
          }}
          onClick={() => {
            if (item.value === 'Percent') {
              handleUpdateFormat(
                'measureFormats',
                {
                  ...formatObject.measureFormats,
                  [formatObject.selectedMeasure?.uId]: {
                    ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                    formatValue: item.value,
                    numberSeparator: 'None',
                  },
                },
                formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
              );
            } else {
              handleUpdateFormat(
                'measureFormats',
                {
                  ...formatObject.measureFormats,
                  [formatObject.selectedMeasure?.uId]: {
                    ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                    formatValue: item.value,
                    percentageCalculate: false,
                  },
                },
                formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
              );
            }
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  const separatorOptions: any[] = [
    { type: 'None', value: 'None' },
    { type: 'Comma', value: 'Comma' },
    { type: 'Abbrev', value: 'Abbrev' },
  ];

  const renderSeparatorOptions = () => {
    return separatorOptions.map((item: any) => {
      const isSelected =
        item.value ===
        formatObject?.measureFormats[formatObject.selectedMeasure?.uId]?.numberSeparator;
      return (
        <div
          key={item.value}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
          }}
          className="radioButton"
          onClick={() => {
            if (
              formatObject.measureFormats[formatObject.selectedMeasure?.uId].formatValue ===
              'Percent'
            )
              return;
            handleUpdateFormat(
              'measureFormats',
              {
                ...formatObject.measureFormats,
                [formatObject.selectedMeasure?.uId]: {
                  ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                  numberSeparator: item.value,
                  percentageCalculate: false,
                },
              },
              formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
            );
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  const handleChartMeasuresSelectChange = (event: any) => {
    const tempSelectedMeasure = event.target.value;
    setSelectedMeasure(tempSelectedMeasure);
    let isDateType = false;
    (function () {
      if (tempSelectedMeasure && tempSelectedMeasure.timeGrain === 'date') {
        if (tempSelectedMeasure.agg) {
          if (tempSelectedMeasure.agg === 'min' || tempSelectedMeasure.agg === 'max') {
            isDateType = true;
          } else {
            isDateType = false;
          }
        } else {
          isDateType = true;
        }
      }
    })();

    // updateFormat(propKey, 'dateFormats', 'selectedMeasureName', event.target.value.displayname);
    handleUpdateFormat(
      'selectedMeasure',
      {
        name: event.target.value?.displayname,
        uId: event.target.value?.uId,
      },
      formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
    );

    if (!formatObject.measureFormats[event.target.value?.uId]) {
      if (formatFor === 'tooltip') {
        handleUpdateFormat(
          'measureFormats',
          {
            ...chartControls.properties[propKey].formatOptions.tooltipFormats.measureFormats,
            [event.target.value?.uId]: isDateType
              ? {
                  formatValue: 'Date',
                  finalDateFormat:
                    formatObject.measureFormats[event.target.value?.uId]?.finalDateFormat || '',
                  selectedMeasureFormat: event.target.value.displayname,
                }
              : {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: true,
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
          },
          'tooltipFormats',
        );
      } else {
        handleUpdateFormat(
          'measureFormats',
          {
            ...chartControls.properties[propKey].formatOptions.labelFormats.measureFormats,
            [event.target.value?.uId]: isDateType
              ? {
                  formatValue: 'Date',
                  finalDateFormat:
                    formatObject.measureFormats[event.target.value?.uId]?.finalDateFormat || '',
                  selectedMeasureFormat: event.target.value.displayname,
                }
              : {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: true,
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
          },
          'labelFormats',
        );
      }
    }
  };
  if (chartType === 'sankey') {
    return null;
  }
  return (
    <React.Fragment>
      {formatFor !== 'tooltip' &&
        (chartProperties.properties[propKey].chartType === 'crossTab' ||
        chartProperties.properties[propKey].chartType === 'richText' ? (
          <>
            <div
              className="optionDescription"
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              FORMAT
            </div>
          </>
        ) : (
          // Main heading for other charts in Label tab
          <>
            {chartType !== 'boxPlot' &&
              chartType !== 'simplecard' &&
              chartType !== 'funnel' &&
              chartType !== 'table' && (
                <div
                  style={{
                    borderTop: '1px solid rgb(211,211,211)',
                    margin: '0.8rem 2% 0.7rem',
                  }}
                ></div>
              )}
            <div
              className="optionDescription"
              style={{
                marginTop:
                  chartType === 'table' || chartType === 'boxPlot' || chartType === 'simplecard'
                    ? '10px'
                    : '0',
                marginBottom: '10px',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              {chartType === 'simplecard'
                ? 'MEASURE FORMAT'
                : chartType === 'boxPlot'
                  ? 'OUTLIER LABEL FORMAT'
                  : 'LABEL FORMAT'}
            </div>
          </>
        ))}
      <>
        {chartControls.properties[propKey].sortedValue ? null : (
          <div
            className="optionDescription"
            style={{
              marginBottom: '2px',
              marginTop: '-4px',
              lineHeight: '1',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            {formatFor === 'tooltip' ? 'Format Measure' : 'Measure'}
          </div>
        )}

        <FormControl fullWidth sx={{ margin: '0px 5px 8px 5px' }}>
          <Select
            sx={{
              width: '96%',
              height: '26px',
              fontSize: '13px',
              textAlign: 'left',
              color: iconColor ? iconColor : '#404040',
              '&.MuiOutlinedInput-root': {
                '& fieldset': {
                  border: '1px solid rgb(211, 211, 211)', // Change the border color here
                },
                '&:hover fieldset': {
                  border: '1px solid #2bb9bb', // Change the hover border color here
                },
                '&.Mui-focused fieldset': {
                  border: '1px solid #2bb9bb', // Change the focused border color here
                },
                '&.Mui-focused svg': {
                  color: '#2bb9bb', // Change the arrow color when focused
                },
                '& svg': {
                  color: iconColor ? iconColor : '#404040',
                },
              },
            }}
            onChange={handleChartMeasuresSelectChange}
            value={
              formatFor === 'tooltip'
                ? Object.keys(tooltipFormats.measureFormats).includes(selectedMeasure?.uId)
                  ? selectedMeasure
                  : null
                : selectedMeasure
            }
            renderValue={(selected) => {
              const axisName = getNameFromUid(
                chartAxes,
                selected.uId,
                formatFor === 'tooltip' && tooltipFormats,
              );
              return axisName;
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  marginLeft: '5px',
                },
              },
            }}
          >
            {measuresList.map((item: any, index: number) => {
              return (
                <MenuItem
                  key={index}
                  value={item}
                  sx={{
                    color: 'black',
                    fontSize: '12px',
                    padding: '2px 10px',
                    '&:hover': { backgroundColor: 'rgb(238, 238, 238)' },
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(43, 185, 187, 0.1)',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.2)',
                    },
                  }}
                >
                  {item?.displayname}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </>

      {isTextType ? (
        <div className="noteStyle" style={{ padding: '5px 15px' }}>
          Format for this measure is not available.
        </div>
      ) : isDateType ? (
        <DateFormat
          propKey={propKey}
          handleUpdateFormat={handleUpdateFormat}
          formatObject={formatObject}
        />
      ) : (
        <React.Fragment>
          <div style={{ marginBottom: '10px' }}>
            <div
              className="optionDescription"
              style={{
                marginTop: '0px',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              {chartType === 'boxPlot' && formatFor !== 'tooltip'
                ? 'Outlier Value'
                : 'Format Value'}
            </div>
            <div className="radioButtons" style={{ padding: '0' }}>
              {renderFormatOptions()}
            </div>
          </div>
          {/* renders radio buttons for percentage calculation or just show the value */}
          {formatObject.measureFormats[formatObject.selectedMeasure?.uId]?.formatValue ===
          'Percent' ? (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  marginTop: '-10px',
                  marginBottom: '10px',
                }}
              >
                <div
                  className="optionDescription"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    color: iconColor ? iconColor : '#404040',
                  }}
                >
                  <span> Percent Type </span>
                  <Tooltip
                    placement="top"
                    arrow
                    title={
                      <div>
                        <p style={{ margin: 0, padding: 0 }}>
                          Calculated: Multiplies by 100 and appends the % symbol.
                        </p>
                        <p style={{ margin: 0, padding: 0 }}>
                          Non Calculated: Appends the % symbol.
                        </p>
                      </div>
                    }
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '11px',
                        },
                      },
                    }}
                  >
                    <InfoOutlineIcon fontSize="small" />
                  </Tooltip>
                </div>
                <div className="radioButtons" style={{ padding: '0' }}>
                  <div
                    className={
                      formatObject.measureFormats[formatObject.selectedMeasure.uId]
                        ?.percentageCalculate === true
                        ? 'radioButtonSelected'
                        : 'radioButton'
                    }
                    style={{
                      backgroundColor:
                        formatObject.measureFormats[formatObject.selectedMeasure.uId]
                          ?.percentageCalculate === true
                          ? 'rgba(224, 224, 224, 1)'
                          : 'white',
                      cursor:
                        formatObject.measureFormats[formatObject.selectedMeasure.uId]
                          ?.percentageCalculate === true
                          ? 'auto'
                          : 'pointer',
                      fontWeight:
                        formatObject.measureFormats[formatObject.selectedMeasure.uId]
                          ?.percentageCalculate === true
                          ? '600'
                          : 'normal',
                    }}
                    onClick={() => {
                      handleUpdateFormat(
                        'measureFormats',
                        {
                          ...formatObject.measureFormats,
                          [formatObject.selectedMeasure.uId]: {
                            ...formatObject.measureFormats[formatObject.selectedMeasure.uId],
                            percentageCalculate: true,
                          },
                        },
                        formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                      );
                    }}
                  >
                    Calculated
                  </div>
                  <div
                    className={
                      formatObject.measureFormats[formatObject.selectedMeasure.uId]
                        ?.percentageCalculate === false
                        ? 'radioButtonSelected'
                        : 'radioButton'
                    }
                    style={{
                      backgroundColor:
                        formatObject.measureFormats[formatObject.selectedMeasure.uId]
                          ?.percentageCalculate === false
                          ? 'rgba(224, 224, 224, 1)'
                          : 'white',
                      cursor:
                        formatObject.measureFormats[formatObject.selectedMeasure.uId]
                          ?.percentageCalculate === false
                          ? 'auto'
                          : 'pointer',
                      fontWeight:
                        formatObject.measureFormats[formatObject.selectedMeasure.uId]
                          ?.percentageCalculate === false
                          ? '600'
                          : 'normal',
                    }}
                    onClick={() => {
                      handleUpdateFormat(
                        'measureFormats',
                        {
                          ...formatObject.measureFormats,
                          [formatObject.selectedMeasure.uId]: {
                            ...formatObject.measureFormats[formatObject.selectedMeasure.uId],
                            percentageCalculate: false,
                          },
                        },
                        formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                      );
                    }}
                  >
                    Non Calculated
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
          {formatObject.measureFormats[formatObject.selectedMeasure?.uId]?.formatValue ===
          'Currency' ? (
            <>
              <div
                className="optionDescription"
                style={{
                  marginTop: '2px',
                  marginBottom: '0px',
                  color: iconColor ? iconColor : '#404040',
                }}
              >
                Currency Symbol
              </div>
              <div
                style={{
                  padding: '0',
                  marginTop: '0px',
                  marginBottom: '8px',
                  marginLeft: '5px',
                  marginRight: '5px',
                }}
              >
                <TextField
                  id="currency-symbol-input"
                  variant="outlined"
                  value={
                    formatObject.measureFormats[formatObject.selectedMeasure.uId]?.currencySymbol ??
                    '$'
                  }
                  onChange={(e) =>
                    handleUpdateFormat(
                      'measureFormats',

                      {
                        ...formatObject.measureFormats,

                        [formatObject.selectedMeasure.uId]: {
                          ...formatObject.measureFormats[formatObject.selectedMeasure.uId],

                          currencySymbol: e.target.value,
                        },
                      },

                      formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                    )
                  }
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      height: '26px',
                      backgroundColor: 'white',
                      fontSize: '13px',
                      '& fieldset': {
                        border: '1px solid rgb(211, 211, 211)',
                      },
                      '&:hover fieldset': {
                        border: '1px solid #2bb9bb',
                      },
                      '&.Mui-focused fieldset': {
                        border: '1px solid #2bb9bb',
                      },
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '0 8px',
                    },
                  }}
                />
              </div>
            </>
          ) : null}
          {formatObject?.measureFormats[formatObject.selectedMeasure?.uId]?.formatValue !==
            'Percent' && (
            <>
              <div style={{ marginBottom: '0px' }}>
                <div
                  className="optionDescription"
                  style={{
                    marginTop: '0px',
                    marginBottom: '0px',
                    color: iconColor ? iconColor : '#404040',
                  }}
                >
                  Separator
                </div>
                <div className="radioButtons" style={{ paddingLeft: '2px' }}>
                  {renderSeparatorOptions()}
                </div>
              </div>
            </>
          )}
          <div
            className="optionDescription"
            style={{
              marginTop: '0px',
              marginBottom: '0px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Round Off
          </div>
          <div
            className="optionDescription"
            style={{
              paddingTop: '0px',
              paddingBottom: '0px',
              marginTop: '-7px',
              paddingLeft: '4px',
              paddingRight: '8px',
              display: 'flex',
              alignItems: 'center',
              backgroundColor: backgroundColor ? backgroundColor : 'white',
            }}
          >
            <Checkbox
              id="enableDisable"
              checked={
                formatObject?.measureFormats[formatObject.selectedMeasure?.uId]?.enableRounding
                  ? true
                  : false
              }
              style={{
                transform: 'scale(0.8)',
                paddingRight: '0px',
                paddingLeft: '0px',
              }}
              sx={{
                color: iconColor || '#a6a6a6',
                '&.Mui-checked': {
                  color: iconColor || '#a6a6a6',
                },
                '&:hover': {
                  backgroundColor: 'transparent !important',
                },
              }}
              onChange={() => {
                handleUpdateFormat(
                  'measureFormats',
                  {
                    ...formatObject.measureFormats,
                    [formatObject.selectedMeasure?.uId]: {
                      ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                      enableRounding:
                        !formatObject.measureFormats[formatObject.selectedMeasure?.uId]
                          ?.enableRounding,
                    },
                  },
                  formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                );
              }}
            />
            <InputPositiveNumber
              value={
                formatObject.measureFormats[formatObject.selectedMeasure?.uId]?.roundingDigits !==
                ''
                  ? formatObject.measureFormats[formatObject.selectedMeasure?.uId]?.roundingDigits
                  : 1
              }
              updateValue={(value: number) => {
                if (value >= 0 && value <= 4) {
                  handleUpdateFormat(
                    'measureFormats',
                    {
                      ...formatObject.measureFormats,
                      [formatObject.selectedMeasure?.uId]: {
                        ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                        roundingDigits: value,
                      },
                    },
                    formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                  );
                } else if (value > 4) {
                  handleUpdateFormat(
                    'measureFormats',
                    {
                      ...formatObject.measureFormats,
                      [formatObject.selectedMeasure?.uId]: {
                        ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                        roundingDigits: 4,
                      },
                    },
                    formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                  );
                } else {
                  handleUpdateFormat(
                    'measureFormats',
                    {
                      ...formatObject.measureFormats,
                      [formatObject.selectedMeasure?.uId]: {
                        ...formatObject.measureFormats[formatObject.selectedMeasure?.uId],
                        roundingDigits: 0,
                      },
                    },
                    formatFor === 'tooltip' ? 'tooltipFormats' : 'labelFormats',
                  );
                }
              }}
              disabled={
                formatObject?.measureFormats[formatObject.selectedMeasure?.uId]?.enableRounding
                  ? false
                  : true
              }
              fromFormats={true}
              //width="2.125rem"
              selectedMeasure={formatObject.selectedMeasure}
              iconColor={iconColor}
              backgroundColor={backgroundColor ? backgroundColor : 'white'}
            />
            <span
              style={{
                margin: '0 auto',
                fontWeight: 'normal',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              decimal
            </span>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: ChartOptionsStateProps & any, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
    dynamicMeasureState: state.dynamicMeasuresState,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateFormat: (propKey: string, formatType: any, option: string, value: any) =>
      dispatch(updateFormatOption(propKey, formatType, option, value)),
    updateFormatForDm: (dmKey: string, option: string, value: any) =>
      dispatch(updateFormatForDm(dmKey, option, value)),
    updateFormatX: (propKey: string, formatType: string | any, option: string, value: any) =>
      dispatch(updateFormatOption(propKey, formatType, option, value)),
    updateFormatY: (propKey: string, formatType: string | number, option: string, value: any) =>
      dispatch(updateFormatOption(propKey, formatType, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelFormatting);
